const ActivityHeader = () => {
  return (
    <div className="space-y-1">
      <h1 className="text-2xl font-semibold text-gray-800">
        Dashboard Overview
      </h1>
      <p className="text-sm text-gray-500">Wednesday, December 10, 2025</p>
    </div>
  );
};

export default ActivityHeader;
